var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"booking":_vm.booking,"form":_vm.form,"dialog":_vm.dialog},on:{"save":_vm.onSave,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }